import {
  Button,
  makeStyles,
  Tab,
  TabList,
  tokens,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Orders } from "./Orders";
import { Tickets } from "./Tickets";
import { CreateTicketModal } from "./CreateTicketModal";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: " center",
    marginTop: tokens.spacingVerticalXXXL,
  },
  contentContainer: {
    minWidth: "405px",
  },
  title: {
    lineHeight: tokens.lineHeightBase400,
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
  },
  itemWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: tokens.spacingVerticalM,
    gap: tokens.spacingHorizontalXL,
  },
  button: {
    height: "fit-content",
    padding: `${tokens.spacingHorizontalS}`,
  },
});

export const Content = (): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("orders");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <div className={styles.itemWrapper}>
          <TabList
            defaultSelectedValue="orders"
            onTabSelect={(_, data) => setSelectedTab(data.value as string)}
          >
            <Tab value="orders">
              <label className={styles.title}>{t("labels.orders")}</label>
            </Tab>
            <Tab value="tickets">
              <label className={styles.title}>{t("labels.tickets")}</label>
            </Tab>
          </TabList>
          <Button
            className={styles.button}
            onClick={() => setIsModalOpen(true)}
            appearance="primary"
          >
            {t("buttons.createTicket")}
          </Button>
        </div>
        {selectedTab === "orders" && <Orders />}
        {selectedTab === "tickets" && <Tickets />}
        <CreateTicketModal open={isModalOpen} onOpenChange={setIsModalOpen} />
      </div>
    </div>
  );
};
